<template>
  <div>
    <v-breadcrumbs class="systock-breadcrump" dark>
      <v-breadcrumbs-item :title="breadcrumb"
        >{{ breadcrumb }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-card flat class="acl-configuracao">
      <v-tabs centered>
        <v-tab @click="breadcrumb = 'CONTROLE DE ACESSO / USUÁRIOS'">
          <v-icon left>mdi-account</v-icon>
          Usuários
        </v-tab>
        <v-tab @click="breadcrumb = 'CONTROLE DE ACESSO / MÓDULOS'">
          <v-icon left>mdi-view-module</v-icon>
          Módulos
        </v-tab>
        <v-tab @click="breadcrumb = 'CONTROLE DE ACESSO / PERFIL'">
          <v-icon left>mdi-account-details</v-icon>
          Perfil
        </v-tab>
        <v-tab @click="breadcrumb = 'CONTROLE DE ACESSO / APLICATIVOS'">
          <v-icon left>mdi-apps</v-icon>
          Aplicativos
        </v-tab>
        <v-tab @click="breadcrumb = 'CONTROLE DE ACESSO / PERMISSÕES'">
          <v-icon left>mdi-account-key</v-icon>
          Permissões
        </v-tab>
        <v-tab-item class="ma-0">
          <acl-usuario :atualizarUsu="atualizarUsu"></acl-usuario>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <acl-modulos @atualizarApp="atualizarApp = $event"></acl-modulos>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <acl-perfis
            @atualizarPermUsu="
              (atualizarPerm = $event), (atualizarUsu = $event)
            "
          ></acl-perfis>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <acl-apps
            @atualizarPerm="atualizarPerm = $event"
            :atualizarApp="atualizarApp"
          ></acl-apps>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <acl-grant :atualizarPerm="atualizarPerm"></acl-grant>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import AclUsuario from "../acl/AclUsuario";
import AclModulos from "../acl/AclModulos";
import AclPerfis from "../acl/AclPerfis";
import AclApps from "../acl/AclApps";
import AclGrant from "../cadastros/Permissoes";

export default {
  components: {
    AclUsuario,
    AclModulos,
    AclPerfis,
    AclApps,
    AclGrant,
  },
  name: "Acl",
  data() {
    return {
      atualizarApp: 0,
      atualizarPerm: 0,
      atualizarUsu: 0,
      breadcrumb: "CONTROLE DE ACESSO / USUÁRIOS",
    };
  },
  created() {
    this.Helpers.verificarToken();
  },
};
</script>

<style>
.tabela-responsiva .v-data-table__wrapper {
  overflow: auto !important;
}
.acl-configuracao .input-descricao input {
  text-transform: uppercase;
}
.systock-breadcrump {
  background-color: #042333;
  height: 2.5em;
  padding-bottom: 0;
  padding-top: 0;
  font-weight: bold;
}
.acl-configuracao .v-btn:not(.v-btn--round).v-size--default {
  height: 40px;
}
.acl-configuracao .v-data-footer__select .v-select {
  margin: 4px 0 6px 16px !important;
}
.acl-configuracao .v-data-table .v-toolbar__content {
  border-bottom: 1px solid #e0e0e0;
}
.acl-configuracao .v-data-table--fixed-header .v-data-footer {
  margin-right: 0;
  padding-right: 16px;
}
.acl-configuracao .v-tabs .v-tabs-bar {
  background-color: #7979790a !important;
}
@media (min-width: 700px) {
  .table-acl-resposivo .v-data-table__wrapper {
    height: calc(100vh - 270px) !important;
    /* height: calc(100vh - 223px) !important; */
  }
}
</style>
